import { Wordmark } from '@novaquantis/design-system';

interface BrandMarkProps {
  wordmarkSize?: number;
  logoClassName?: string;
}

const BrandMark = ({
  wordmarkSize = 22,
  logoClassName = 'h-8 w-8 shrink-0 object-contain',
}: BrandMarkProps) => (
  <span className="inline-flex items-center gap-2.5">
    <img
      src="/assets/logo-bull-trim.png"
      alt=""
      aria-hidden="true"
      className={logoClassName}
      width={32}
      height={32}
    />
    <Wordmark size={wordmarkSize} />
  </span>
);

export default BrandMark;
